var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAskAnExpertIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.2,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.094 12.219H7.53l-3.75 2.812V12.22H1.906a.938.938 0 0 1-.937-.938V1.906A.937.937 0 0 1 1.906.97h12.188a.937.937 0 0 1 .937.937v9.375a.938.938 0 0 1-.937.938Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5.362c0-.25.064-.495.186-.708a1.32 1.32 0 0 1 .504-.502 1.21 1.21 0 0 1 1.324.098c.19.144.341.342.434.57.093.23.125.482.093.729s-.127.48-.275.674a1.28 1.28 0 0 1-.564.423.644.644 0 0 0-.308.249.712.712 0 0 0-.117.393v.116M8.25 9a.2.2 0 0 1 0-.398m0 .398a.2.2 0 0 0 0-.398"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskAnExpertIcon);
export default __webpack_public_path__ + "static/media/ask-an-expert-icon.364a9576c560906625a86872158e8f62.svg";
export { ForwardRef as ReactComponent };